import { Box, Grid } from '@domain-group/suit-theme'

import useCarousel from '@hooks/useCarousel'

import ImageTile from './ImageTile'
import Preview from './Preview'

import type { UseCampaignImagesPayload } from '../../../hooks/useCampaignImages'

interface GridViewProps {
  campaignImagesPayload: UseCampaignImagesPayload,
  largeGrid?: boolean,
}

const GridView = (props: GridViewProps) => {
  const { campaignImagesPayload, largeGrid = false } = props

  const {
    bulkSelecting,
    callbacks: { toggleId },
    campaign,
    exportSizeErrorImageIds,
    filteredImages,
    hasPublicImages,
    selectedEntityIds,
  } = campaignImagesPayload

  const carouselPayload = useCarousel({ items: filteredImages })
  const { callbacks: { setSelectedIndex }, hasSelectedIndex, selectedIndex } = carouselPayload

  return (
    <Box flexDirection="column" flexShrink={0}>
      {hasSelectedIndex && (
        <Preview
          callbacks={{ unselectImage: () => setSelectedIndex(undefined) }}
          campaign={campaign}
          carouselPayload={carouselPayload}
          image={filteredImages[selectedIndex!]}
        />
      )}

      <Grid
        // @ts-expect-error TS2322
        gridGap="medium"
        gridAutoRows={largeGrid ? 'auto' : '1fr'}
        gridTemplateColumns={largeGrid ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(180px, 1fr))'}
        gridTemplateRows={largeGrid ? undefined : 'repeat(auto-fill, minmax(140px, 1fr))'}
        padding="large"
      >
        {filteredImages.map((image, index) => {
          const selectionIndex = selectedEntityIds.findIndex(imageId => image.id === imageId)
          const hasExportSizeError = exportSizeErrorImageIds.includes(image.id)

          return (
            <ImageTile
              bulkSelecting={bulkSelecting}
              callbacks={{
                toggleId,
                selectImage: () => setSelectedIndex(index),
              }}
              fadePrivate={hasPublicImages}
              hasExportSizeError={hasExportSizeError}
              image={image}
              key={image.id}
              selectionIndex={selectionIndex}
              square={largeGrid}
            />
          )
        })}
      </Grid>
    </Box>
  )
}

export default GridView
